import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import {FormControl, FormLabel} from "@material-ui/core";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import {CheckListResources} from "../endpoints";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";

class DialogCheckList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            valores :[],
            files : [],
            observaciones:[],
            estados:[],
            resultados :[],
            cantidad_files:0,
            porcentaje: 9,
        }
    }

     handleRadioChange = (event,valor) => {
         let value = event.target.value === '1'
         let datos = this.state.valores
         const index = datos.indexOf(valor)
         datos[index].estado = value
         this.setState({valores:datos})
         this.setState(
             ({estados}) => ({
                 estados: {
                     ...estados,
                     [event.target.name]: event.target.value
                 }}),
         )
    };

    handleObservacionesChange = (event) => {
        this.setState(
            ({observaciones}) => ({
                observaciones: {
                    ...observaciones,
                    [event.target.name]: event.target.value
                }
            })
        );
    };

    getValoresCheckList = () =>{
        //this.getPorcentaje();
        CheckListResources.getValores().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            const estados = {}
            for (let i = 0; i < result.length; i++) {
                estados[result[i].id] = result[i].estado === true ? '1' : '0'
            }
            this.setState({valores:result, estados : estados})
        }).catch(error=> {
            console.log(error)
        });
    }

    handleOnFileChange = (e) => {
        let file = e.target.files[0];
        this.setState(
            ({files}) => ({
                files: {
                    ...files,
                    [e.target.id]: file
                }
            })
        );
    }
     postImage = () => {
        let resultados = []
        //const files = Object.entries(this.state.files).map((e) => ( { [e[0]]: e[1] } ));
        const files = Object.entries(this.state.files)
        const cantidad_files = files.length
        files.map(([key,value])=> {
            const formData = new FormData();
            formData.append("file", value);
            return CheckListResources.postImages(formData, key).then( response => {
                if (response) {
                    return  response.json()
                }
            }).then(result => {
                if (result.status_code === 200) {
                    resultados.push(true)
                }
            }).catch(error => {
                resultados.push(false)
                console.error(error)
            });
        })
         this.setState({cantidad_files:cantidad_files, resultados:resultados}, () => {this.submitForm()})
    }

    submitForm = () => {
        this.setState({progress:true,disabled:true, open:false})
        const estados =  Object.entries(this.state.estados)
        const list={
            datos: []
        }
        estados.map(([key,value])=>{
            let observacion = ''
            if(this.state.observaciones[key]){
                observacion = this.state.observaciones[key]
            }
            const datosCheckList = {
                id : key,
                observacion:observacion,
                estado: value
            }
            list.datos.push(datosCheckList)
            return '';
        })

        if (this.state.resultados.length === this.state.cantidad_files){
            CheckListResources.updateCheckList(list).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result=> {
                if(result.message){
                    this.props.refrescar(result.message,result.severity)
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                this.props.refrescar("Ha ocurrido un error inesperado", "error")
                console.log(error)
            });
        }
        else{
            this.props.refrescar("Error al guardar las imagenes", "error")
        }
    }

    componentDidMount() {
        this.getValoresCheckList();
    }

    render() {
        return(
            <Dialog
                open={true}
                fullWidth
                maxWidth={"md"}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Check list validación</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        {this.state.valores.map((valor)=>{
                            return  <Grid item xs={12} key={(valor.id).toString()}>
                                <Grid item xs={12}>
                                <FormControl disabled={valor.id === 4}>
                                    <FormLabel>{(valor.id).toString()+". "+valor.descripcion} </FormLabel>
                                    <RadioGroup
                                        onChange={(e)=>{this.handleRadioChange(e,valor)}}
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name={(valor.id).toString()}
                                    >
                                        <FormControlLabel checked={valor.estado === true } value="1" control={<Radio />} label="Cumple" />
                                        <FormControlLabel checked={valor.estado === false } value="0" control={<Radio />} label="No cumple" />
                                    </RadioGroup>
                                </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box>
                                        <TextField
                                            variant="outlined"
                                            id="standard-multiline-flexible"
                                            label="Observación"
                                            multiline
                                            fullWidth
                                            rowsMax={2}
                                            defaultValue={valor.observacion}
                                            disabled={valor.id === 4}
                                            name={(valor.id).toString()}
                                            onChange={this.handleObservacionesChange}
                                        />
                                    </Box>
                                </Grid>
                                <br/>
                                <Grid item xs={12}>
                                <TextField
                                    inputProps={{accept:'.jpg, .png'}}
                                    disabled={!this.state.estados[(valor.id).toString()]}
                                    style={{width:'auto'}}
                                    type={"file"}
                                    id={(valor.id).toString()}
                                    label="Seleccione archivo"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    disabled={valor.id === 4}
                                    variant="outlined"
                                    onChange={this.handleOnFileChange}
                                />
                                </Grid>
                            </Grid>
                        })}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="contained" disabled={(Object.entries(this.state.estados).length<25)} onClick={this.submitForm} color="primary">
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }
}

export default DialogCheckList;